<template>
  <div class="about">
    <div
      class="mobile-show"
      style="
    width: 100vw;
    height: calc(100vw * 0.125);
    position:absolute;
    top:0;
    background: url(./img/mobile_header_bg1.jpg) center top  / cover;
    background-repeat: no-repeat;
    "
    ></div>
    <div class="container mobile-hide">
      <agile
        ref="imagecarousel"
        :autoplay="false"
        :speed="2000"
        :fade="true"
        :dots="false"
        :nav-buttons="false"
        style="height:400px;overflow:hidden;"
      >
        <div
          class="slide"
          style="background: url('./img/about_slide01.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide02.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide03.jpg') center center / cover;"
        ></div>
        <div
          class="slide"
          style="background: url('./img/about_slide04.jpg') center center / cover;"
        ></div>
      </agile>
      <div class="slidetextbg"></div>
      <div class="slidetext tablet-offset">{{$t('body.about_slide')}}</div>
      <div
        style="
      width: 100%;
      height: 133px;
      position: absolute;
      top: 370px;
      background: url(./img/about_overlay.png) center center / cover;
      mix-blend-mode:multiply;
      "
      ></div>
      <div class="container" style="position:absolute;top:0;right:0;">
        <agile
          :autoplay="true"
          :speed="2000"
          :autoplay-speed="5000"
          :fade="true"
          :dots="true"
          :nav-buttons="false"
          style="height:500px;overflow:hidden;"
          @beforeChange="syncslide"
        >
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_vision.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_trust.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_persist.png" alt width="48" />
            </div>
          </div>
          <div class="slide" style="width:100%;height:500px;">
            <div class="slide-overlay">
              <img src="img/chinese_determin.png" alt width="48" />
            </div>
          </div>
        </agile>
      </div>
    </div>

    <div class="mobile-unpad">
      <div
        class="container mobile-padding mobile-bg-blue"
        style="text-align:left;padding-top:30px;padding-bottom:30px;"
      >
        <span class="title-size">{{$t('body.aboutus_whoweare_title')}}</span>
        <div class="subtitlebodyblue">{{$t('body.aboutus_whoweare_p1')}}</div>
      </div>
      <u-animate-container>
        <u-animate
          name="fadeInUp"
          delay="0s"
          duration="2s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          <parallax
            class="mobile-hide"
            :imagelink="'./img/about_whoweare01.jpg'"
            :pspeed="1.5"
            :containerheight="'450px'"
          ></parallax>
          <div
            class="mobile-show"
            style="
          width:100%;
          height:250px;
          background:url('./img/about_whoweare01.jpg') center center / cover;
          "
          ></div>
        </u-animate>
      </u-animate-container>

      <div
        class="container mobile-padding"
        style="text-align:left;margin-top:30px;margin-bottom:16px;"
      >
        <div class="columns">
          <div class="column blue-title">
            <span
              class="title-size"
              style="font-weight:900;font-family:AvenirBold;"
            >{{$t('body.aboutus_whoweare_title2')}}</span>
            <span class="title-size mobile-hide-inline">{{$t('body.aboutus_whoweare_title3')}}</span>
            <span
              class="title-size mobile-show"
              style="position:relative; top:-10px;"
            >{{$t('body.aboutus_whoweare_title3')}}</span>
          </div>
        </div>
        <div class="columns bodygrey">
          <div class="column mobile-column-padding-bottom mobile-column-padding-right">
            <div>{{$t('body.aboutus_whoweare_p2_1')}}</div>
          </div>
          <div class="column">
            <div style="margin-bottom:20px;">{{$t('body.aboutus_whoweare_p2_2')}}</div>
            <div>{{$t('body.aboutus_whoweare_p2_3')}}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="position:relative;top:170px;">
      <vfooter></vfooter>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "about",
  mounted() {
    // let self = this;
    // console.log("hello");
    // bulmaSteps.attach();
  },
  methods: {
    syncslide() {
      let self = this;
      console.log("syncslide");
      self.$refs.imagecarousel.goToNext();
    }
  }
};
</script>

<style scoped lang="scss">
.slide {
  width: 100%;
  height: 400px;
  // background: url("../assets/logo.png");
}

.slidetextbg {
  width: 500px;
  height: 400px;
  background: linear-gradient(to right, #013d57dd 70%, #013d5700);
  mix-blend-mode: multiply;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: justify;
  padding: 24px 200px 0 24px;
  font-size: 20px;
}

.slidetext {
  width: 550px;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;
  color: white;
  text-align: left;
  line-height: 29px;
  padding: 24px 200px 0 24px;
  font-size: 25px;
}
.slide-overlay {
  width: calc(1000px - 126px);
  height: inherit;
  font-size: 40px;
  line-height: 1;
  text-align: right;
  color: white;
  border-right: white solid 1px;
  position: relative;
  padding: 0 8px;
  top: 24px;
  // right: -500px;
}

.slide-overlay::after {
  content: "";
  display: block;
  width: 4px;
  height: 100px;
  background: white;
  position: absolute;
  padding-right: 4px;
  top: 0;
  right: 0;
}
// .agile__dots {
//   bottom: 10px;
//   flex-direction: column;
//   right: 30px;
//   position: absolute;
// }
// .agile__dot {
//   margin: 5px 0;
// }
// .agile button {
//   background-color: transparent;
//   border: 1px solid #fff;
//   cursor: pointer;
//   display: block;
//   height: 10px;
//   font-size: 0;
//   line-height: 0;
//   margin: 0;
//   padding: 0;
//   transition-duration: 0.3s;
//   width: 10px;
// }
// .agile--current button,
// .agile:hover button {
//   background-color: #fff;
// }
@media screen and (min-width: 768px) {
  .tablet-offset{
    top:30px;
  }
}
@media screen and (min-width: 992px) {
  .tablet-offset{
    top:0px;
  }
}

</style>